var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43209 2.50205L4.93949 7.30448C4.65052 8.23423 3.34234 8.24697 3.03584 7.32244L2.44564 5.54217L1.96132 6.69872C1.85466 6.95343 1.56171 7.07345 1.307 6.96679C1.05229 6.86012 0.932272 6.56717 1.03894 6.31246L1.52367 5.15493C1.88149 4.30044 3.10351 4.34872 3.39462 5.22683L3.98477 7.00696L5.4774 2.20443C5.78067 1.22866 7.17324 1.28048 7.40567 2.27371L9.09627 9.49805L10.0284 6.84272C10.1198 6.58216 10.4052 6.44509 10.6657 6.53655C10.9263 6.62801 11.0634 6.91337 10.9719 7.17393L10.0395 9.83018C9.70729 10.7766 8.35067 10.7006 8.12268 9.72634L6.43209 2.50205Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.cf2aa05cb30a567ac56a4596eae28838.svg";
export { ForwardRef as ReactComponent };